// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3pc27","amount":"Amount_amount__1xrMo","tip":"Amount_tip__ZpBUZ","tipHeader":"Amount_tipHeader__JBi8z","tipsWrap":"Amount_tipsWrap__nQ3ZR"};